import { signIn } from "supertokens-web-js/recipe/emailpassword";

export interface SignInResponse {
  status: "OK" | "FIELD_ERROR" | "WRONG_CREDENTIALS_ERROR" | "SIGN_IN_NOT_ALLOWED";
  formFields?: Array<{
    id: string;
    error: string;
  }>;
  reason?: string;
  requiresCaptcha?: boolean;
  error?: string;
}

export const authService = {
  async signIn(email: string, password: string, captchaToken?: string): Promise<SignInResponse> {
    try {
      return await signIn({
        formFields: [
          { id: "email", value: email },
          { id: "password", value: password }
        ],
        options: {
          preAPIHook: async (context) => {
            context.requestInit.credentials = "include";
            // Add hCaptcha token if present
            if (captchaToken) {
              const body = JSON.parse(context.requestInit.body as string);
              body.hcaptchaToken = captchaToken;
              context.requestInit.body = JSON.stringify(body);
            }
            return context;
          }
        }
      }) as SignInResponse;
    } catch (error: any) {
      // Handle rate limiting and CAPTCHA requirements
      if (error.response?.status === 429) {
        const data = await error.response.json();
        return {
          status: "WRONG_CREDENTIALS_ERROR",
          requiresCaptcha: data.requiresCaptcha || false,
          error: data.error || "Too many failed attempts. Please complete the CAPTCHA."
        };
      }
      throw error;
    }
  }
}; 